import React, { useEffect, useState } from 'react';
import BoxWrapper from '../boxwra';
import ConfirmationDialog from '../../../Sales/TDSReconciliationSale/ConfirmationDailog';
import { Snackbar, Alert } from '@mui/material';

function FourPointOne({ handleBack, updateTableData, data }) {
  const [tableData, setTableData] = useState(data);
  const [tableName, setTableName] = useState("4.Details of advances, inwards and outward supplies made during the financial year on which tax is payable");
  const [saveDailog, setSaveDailogOpen] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [confirmBack, setConfirmBack] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const submitHandle = () => {
    // Prepare data with fresh calculated values for subtotal rows
    const dataToSubmit = tableData.map((item) => {
      // const isSubTotalRow = [
      //   "(H) Sub total (A to G above)",
      //   "(M) Sub total (I to L above)",
      //   "(N) Supplies and advances on which tax is to be paid (H + M) above"
      // ].includes(item.name);
      const isSubTotalRow = [
        "(H) Sub-total (A to G1 above)",
        "(M) Sub-total (I to L above)",
        "(N) Supplies and advances on which tax is to be paid (H + M) above"
      ].includes(item.name);

      if (isSubTotalRow) {
        // Inject live calculated values into the subtotal row
        return {
          ...item,
          taxable_value: getSubTotalRowValue(item, 'taxable_value', tableData),
          igst: getSubTotalRowValue(item, 'igst', tableData),
          cgst: getSubTotalRowValue(item, 'cgst', tableData),
          sgst: getSubTotalRowValue(item, 'sgst', tableData),
          cess: getSubTotalRowValue(item, 'cess', tableData),
        };
      }

      // For normal rows, return as-is (they already have user-entered values)
      return item;
    });

    console.log("Data being saved (with calculated subtotals):", dataToSubmit);

    // Send the complete and accurate data
    updateTableData(tableName, dataToSubmit);

    setUnsavedChanges(false);
    setSaveDailogOpen(false);
    setSnackbarOpen(true);
  };

  const handleBackButton = () => {
    if (unsavedChanges) {
      setConfirmBack(true);
    } else {
      handleBack();
    }
  };

  const confirmBackHandle = () => {
    submitHandle();
    handleBack();
  };

  // Helper function to safely parse values for calculations
  const safeParseFloat = (value) => {
    if (!value || value === '' || value === '-') {
      return 0; // Return 0 for incomplete values during typing
    }

    // Convert to string to safely use string methods
    const stringValue = String(value);
    if (stringValue.endsWith('.')) {
      return 0; // Return 0 for incomplete decimal values during typing
    }

    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const [itemName, field] = name.split('.');

    // Clean the input value but allow intermediate states like "-", "5.", etc.
    const cleanedValue = parseRupee(value);

    // For editable fields, store the cleaned input value
    setTableData((prevData) =>
      prevData.map((item) =>
        item.name === itemName
          ? { ...item, [field]: cleanedValue }
          : item
      )
    );

    setUnsavedChanges(true);

    // Force re-render to update calculated subtotals when any manual input changes
    // This ensures subtotals update immediately when G1 or other manual fields change
    // setTimeout(() => {
    //   setTableData(prev => [...prev]);
    // }, 0);
  };

  const getSubTotalRowValue = (item, key_name) => {
    if (!item || !item.name) return "0.00";

    // Normalize the name: replace en/em dashes with regular hyphen, trim spaces
    const normalizedName = item.name
      .replace(/[\u2013\u2014]/g, '-')  // Replace en-dash and em-dash with hyphen
      .trim();

    let value = 0;

    switch (normalizedName) {
      case "(H) Sub-total (A to G1 above)":
        for (let i = 0; i < 8; i++) {
          if ((key_name === 'cgst' || key_name === 'sgst') && (i === 2 || i === 3)) {
            continue;
          }
          if (tableData[i]) {
            const safeValue = safeParseFloat(tableData[i][key_name]);
            value += safeValue;
          }
        }
        console.log('H subtotal result:', value.toFixed(2));
        return value.toFixed(2);

      case "(M) Sub-total (I to L above)":
        for (let i = 9; i < 13; i++) {
          if (tableData[i]) {
            const safeValue = safeParseFloat(tableData[i][key_name]);
            if (i === 9 || i === 12) {
              value -= safeValue;
            } else {
              value += safeValue;
            }
          }
        }
        return value.toFixed(2);

      case "(N) Supplies and advances on which tax is to be paid (H + M) above":
        // Calculate H
        let hValue = 0;
        for (let i = 0; i < 8; i++) {
          if ((key_name === 'cgst' || key_name === 'sgst') && (i === 2 || i === 3)) {
            continue;
          }
          if (tableData[i]) {
            hValue += safeParseFloat(tableData[i][key_name]);
          }
        }

        // Calculate M
        let mValue = 0;
        for (let i = 9; i < 13; i++) {
          if (tableData[i]) {
            const safeValue = safeParseFloat(tableData[i][key_name]);
            if (i === 9 || i === 12) {
              mValue -= safeValue;
            } else {
              mValue += safeValue;
            }
          }
        }

        value = hValue + mValue;
        return value.toFixed(2);

      default:
        return "0.00"; // or return undefined, depending on your needs
    }
  };

  const formatRupee = (value, isManualType = false) => {
    // For manual type fields, if value is empty, null, undefined, or 0, return empty string
    if (isManualType && (!value || value === 0 || value === '0' || value === '0.00')) {
      return '';
    }

    if (!value && value !== 0) return '';

    // Check if the value has decimal places
    const hasDecimal = value.toString().includes('.');
    const decimalPlaces = hasDecimal ? value.toString().split('.')[1]?.length || 0 : 0;

    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: hasDecimal && decimalPlaces > 0 ? Math.min(decimalPlaces, 2) : 0,
      maximumFractionDigits: 2,
    });
    return formatter.format(value).replace('INR', '₹');
  };

  const parseRupee = (value) => {
    if (!value) return '';
    // Allow only digits, one decimal point, and optional leading negative sign
    let cleaned = value.replace(/[^0-9.-]/g, '');
    // Ensure only one decimal point
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }
    // Ensure only one negative sign at the beginning
    if (cleaned.startsWith('-')) {
      cleaned = '-' + cleaned.substring(1).replace(/-/g, '');
    } else {
      cleaned = cleaned.replace(/-/g, '');
    }
    return cleaned;
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const renderTableRows = () => {
    const getRowColor = (index) => {
      const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
      return colors[index % colors.length];
    };

    return tableData.map((item, index) => {
      const isSubTotalRow = [
        //"(H) Sub total (A to G above)",
        "(H) Sub-total (A to G1 above)",
        "(M) Sub-total (I to L above)",
        "(N) Supplies and advances on which tax is to be paid (H + M) above"
      ].includes(item.name);

      // Check if this is row C or D (indices 2 or 3)
      const isCOrDRow = index === 2 || index === 3;

      return (
        <div key={index} style={{
          display: 'grid',
          gridTemplateColumns: '60px 1fr 150px 150px 150px 150px 150px',
          gap: '10px',
          alignItems: 'center',
          padding: '8px 10px',
          borderBottom: '1px solid #f1f5f9',
          backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
          borderRadius: '6px',
          marginBottom: '2px',
          minHeight: '50px'
        }}>
          <span style={{
            color: '#1e293b',
            fontSize: '13px',
            fontWeight: '600',
            textAlign: 'center',
            padding: '8px 6px',
            backgroundColor: getRowColor(index),
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {index + 1}
          </span>
          <span style={{
            color: '#334155',
            fontSize: '13px',
            padding: '8px 12px',
            backgroundColor: '#f1f5f9',
            borderRadius: '6px',
            wordBreak: 'break-word',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            minHeight: '34px'
          }}>
            {item.name}
          </span>
          {['taxable_value', 'igst', 'cgst', 'sgst', 'cess'].map((field, idx) => {
            // For rows C and D, don't show values in cgst and sgst columns
            const shouldHideValue = isCOrDRow && (field === 'cgst' || field === 'sgst');

            // For editable fields, show raw value during editing; for display, format if valid number
            let displayValue;
            if (shouldHideValue) {
              displayValue = '';
            } else if (isSubTotalRow) {
              displayValue = (getSubTotalRowValue(item, field));
            } else if (item.manual_type) {
              const rawVal = item[field];
              const numVal = safeParseFloat(rawVal);
              // Convert to string to safely use string methods
              const stringVal = String(rawVal || '');
              displayValue = (rawVal === '' || rawVal === '-' || stringVal.endsWith('.')) ? rawVal : formatRupee(numVal, true);
            } else {
              displayValue = formatRupee(item[field], item.manual_type) || '';
            }

            return (
              <input
                key={`${item.name}.${field}`}
                type="text"
                className='blue-color'
                name={`${item.name}.${field}`}
                value={displayValue}
                onChange={handleInputChange}
                readOnly={isSubTotalRow || !item.manual_type || shouldHideValue}
                style={{
                  color: '#1e293b',
                  fontWeight: '500',
                  fontSize: '13px',
                  textAlign: 'right',
                  padding: '8px 12px',
                  backgroundColor: shouldHideValue ? '#bbb8b8ff' : (isSubTotalRow || !item.manual_type ? '#f0f0f0' : '#ecfdf5'),
                  // backgroundColor: isSubTotalRow || !item.manual_type || shouldHideValue ? '#f0f0f0' : '#ecfdf5',
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  outline: 'none',
                  cursor: isSubTotalRow || !item.manual_type || shouldHideValue ? 'not-allowed' : 'text',
                  minHeight: '34px',
                  boxSizing: 'border-box',
                  width: '100%',
                  ...(isSubTotalRow ? { fontWeight: 'bold', borderColor: 'green', borderWidth: '2px' } : {})
                }}
                onFocus={(e) => {
                  if (!isSubTotalRow && item.manual_type && !shouldHideValue) {
                    // On focus, show raw value without formatting for easier editing
                    const rawVal = item[field] || '';
                    e.target.value = rawVal;
                    e.target.style.borderColor = '#88d8a3';
                    e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
                  }
                }}
                onBlur={(e) => {
                  if (!isSubTotalRow && item.manual_type && !shouldHideValue) {
                    // On blur, re-format the value if it's a valid number
                    const rawVal = e.target.value;
                    const cleanedVal = parseRupee(rawVal);
                    const numVal = safeParseFloat(cleanedVal);
                    // Convert to string to safely use string methods
                    const stringVal = String(cleanedVal || '');
                    const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
                    e.target.value = finalDisplay;
                    // Update state with cleaned value
                    setTableData((prevData) =>
                      prevData.map((it) =>
                        it.name === item.name
                          ? { ...it, [field]: cleanedVal }
                          : it
                      )
                    );
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }
                }}
              />
            );
          })}
        </div>
      );
    });
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '30px',
        width: '100%',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
      }}>
        <BoxWrapper
          backButtonForZohoEnable={true}
          backButton={handleBackButton}
          boxTitle={tableName}
        >
          <p style={{ marginLeft: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Note: </span> The fields where the system computed values would be modified by more/less 20% shall be highlighted in <span style={{ color: 'red' }}>Red</span> for reference and attention.
          </p>
          <hr style={{ marginLeft: '10px' }} />
        </BoxWrapper>

        <div style={{
          maxHeight: 'calc(100vh - 450px)',
          overflowY: 'auto',
          marginTop: '10px'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '60px 1fr 150px 150px 150px 150px 150px',
            gap: '10px',
            alignItems: 'center',
            padding: '8px 10px',
            borderBottom: '2px solid #e2e8f0',
            backgroundColor: '#f8fafc',
            borderRadius: '6px',
            marginBottom: '2px',
            minHeight: '50px',
            fontWeight: '600',
            color: '#475569',
            fontSize: '13px',
            position: 'sticky',
            top: '0',
            zIndex: '10'
          }}>
            <span style={{
              textAlign: 'center',
              padding: '8px 6px',
              backgroundColor: '#e0e7ff',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>S.No.</span>
            <span style={{
              textAlign: 'left',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              display: 'flex',
              alignItems: 'center'
            }}>Nature of Supplies</span>
            <span style={{
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>Taxable value (₹)</span>
            <span style={{
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>Integrated Tax (₹)</span>
            <span style={{
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>Central Tax (₹)</span>
            <span style={{
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>State/UT Tax (₹)</span>
            <span style={{
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>CESS (₹)</span>
          </div>
          {(tableData && tableData.length >= 1) ? renderTableRows() : (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
              No Data Found!
            </div>
          )}
        </div>

        <div style={{
          marginTop: '20px',
          padding: '15px',
          backgroundColor: '#f8fafc',
          borderRadius: '8px',
          borderTop: '2px solid #e2e8f0'
        }}>
          <p style={{ margin: '0', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
            Total Records: {tableData?.length || 0}
          </p>
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '20px',
          gap: '10px'
        }}>
          <button
            type="button"
            className='button-primary'
            onClick={() => setSaveDailogOpen(true)}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
            }}
          >
            Save
          </button>
        </div>
      </div>

      <ConfirmationDialog
        open={saveDailog}
        onClose={() => setSaveDailogOpen(false)}
        onConfirm={submitHandle}
        title="Confirm Save"
        text="Do you want to save your changes? This action will update the current data."
      />

      <ConfirmationDialog
        open={confirmBack}
        onConfirm={confirmBackHandle}
        onClose={() => handleBack()}
        title="Unsaved Changes"
        text="You have unsaved changes. Do you want to leave without saving?"
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000} // Auto-close after 3 seconds
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: '100%' }}
        >
          Data saved successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

export default FourPointOne;